"use client";

import { c as _c } from "react/compiler-runtime";
import type { ProductFiltersResponse } from "@spree/sdk";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback, useTransition } from "react";
import { FilterBar } from "@/components/products/filters";
import { buildListingSearchParams } from "@/lib/utils/listing-search-params";
import type { ActiveFilters } from "@/types/filters";
interface ListingFilterBarProps {
  filtersData: ProductFiltersResponse | null;
  activeFilters: ActiveFilters;
  totalCount: number;
}

/**
 * Thin client wrapper around FilterBar that turns every filter change
 * into a URL update (router.push) instead of local state. The server
 * component that owns this PLP will re-render with new searchParams.
 */
export function ListingFilterBar(t0) {
  const $ = _c(12);
  const {
    filtersData,
    activeFilters,
    totalCount
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [isPending, startTransition] = useTransition();
  let t1;
  if ($[0] !== pathname || $[1] !== router || $[2] !== searchParams) {
    t1 = nextFilters => {
      const next = buildListingSearchParams(new URLSearchParams(searchParams.toString()), {
        query: searchParams.get("q") ?? undefined,
        filters: nextFilters
      });
      const query = next.toString();
      const url = query ? `${pathname}?${query}` : pathname;
      startTransition(() => {
        router.push(url, {
          scroll: false
        });
      });
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleFilterChange = t1;
  let t2;
  if ($[4] !== activeFilters || $[5] !== filtersData || $[6] !== handleFilterChange || $[7] !== totalCount) {
    t2 = <FilterBar filtersData={filtersData} filtersLoading={false} activeFilters={activeFilters} totalCount={totalCount} onFilterChange={handleFilterChange} />;
    $[4] = activeFilters;
    $[5] = filtersData;
    $[6] = handleFilterChange;
    $[7] = totalCount;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== isPending || $[10] !== t2) {
    t3 = <div aria-busy={isPending}>{t2}</div>;
    $[9] = isPending;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}